import { AlertCircle } from "lucide-react";

type PaymentsDisabledContentProps = {
  onClose: () => void;
};

export function PaymentsDisabledContent({
  onClose,
}: PaymentsDisabledContentProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 md:py-12 md:px-6 text-center">
      <div className="p-3 bg-ds-amber-100 rounded-full mb-4">
        <AlertCircle className="w-8 h-8 text-ds-amber-500" />
      </div>

      <h2 className="text-lg md:text-xl font-heading font-bold text-navy-900 mb-2">
        Plățile sunt momentan dezactivate
      </h2>

      <p className="text-sm text-ds-text-600 max-w-sm mb-6">
        Sistemul de plăți este temporar indisponibil. Te rugăm să revii mai
        târziu sau să contactezi echipa de suport pentru mai multe detalii.
      </p>

      <button
        type="button"
        onClick={onClose}
        className="px-4 py-2 md:px-6 md:py-2.5 bg-navy-900 text-white text-sm font-semibold rounded-lg hover:bg-navy-800 transition-colors"
      >
        Am înțeles
      </button>

      <p className="text-xs text-ds-text-400 mt-4">
        Ai nevoie de ajutor?{" "}
        <a href="#suport" className="text-ds-blue-600 underline">
          Contactează suportul
        </a>
      </p>
    </div>
  );
}
